import api from "./api";

function readAssistantData(response) {
  const body = response?.data;
  if (Number(body?.block_status) === 1) {
    const error = new Error(body?.block_reason || "Your account cannot use Chat Voice right now.");
    error.kind = "access";
    throw error;
  }
  if (Number(body?.frontend_maintenance_mode) === 1 && Number(body?.maintenance_access) === 0) {
    throw new Error(body?.frontend_maintenance_message || "Chat Voice is temporarily unavailable.");
  }
  if (body?.error === true || body?.error === 1 || body?.success === false) {
    throw new Error(body?.message || "Chat Voice is unavailable.");
  }
  if (!body?.dataset?.data || typeof body.dataset.data !== "object") {
    throw new Error(body?.message || "Chat Voice returned an invalid response.");
  }
  return body.dataset.data;
}

export function isAssistantUsageBlocked(usage) {
  if (!usage) return false;
  const isPaid = usage.is_paid_user === true || usage.is_paid_user === 1 || usage.is_paid_user === "1";
  return usage.can_continue === false || usage.can_continue === 0 || usage.can_continue === "0" || usage.can_continue === "false" ||
    (!isPaid && Number(usage.daily_credit_limit) > 0 && Number(usage.remaining_credits_today) <= 0);
}

export async function createAssistantSession({ signal } = {}) {
  const response = await api.post("/assistant/realtime/session", {
    voice: "alloy",
    model: "gpt-realtime-mini",
  }, { signal });
  return readAssistantData(response);
}

export async function fetchAssistantUsage({ signal } = {}) {
  const response = await api.get("/assistant/realtime/usage", { signal });
  const usage = readAssistantData(response).usage;
  if (!usage || typeof usage !== "object") throw new Error("Chat Voice credit information is unavailable.");
  return usage;
}

export async function fetchAssistantSessions({ signal } = {}) {
  const response = await api.get("/assistant/realtime/sessions", { signal });
  const sessions = readAssistantData(response).sessions;
  if (!Array.isArray(sessions)) throw new Error("Conversation history returned an invalid response.");
  return sessions;
}

export async function fetchAssistantConversation(sessionLogId, { signal } = {}) {
  const response = await api.get("/assistant/realtime/conversation", {
    params: { session_log_id: sessionLogId }, signal,
  });
  const messages = readAssistantData(response).messages;
  if (!Array.isArray(messages)) throw new Error("Conversation messages returned an invalid response.");
  return [...messages].sort((a, b) => (Number(a.sequence) || 0) - (Number(b.sequence) || 0));
}

export async function saveAssistantMessage({ sessionLogId, role, message, sequence }, { signal } = {}) {
  const response = await api.post("/assistant/realtime/conversation", {
    session_log_id: sessionLogId, role, message, sequence,
  }, { signal });
  const body = response?.data;
  if (body?.error === true || body?.error === 1 || body?.success === false) {
    throw new Error(body?.message || "Could not save the conversation message.");
  }
  return body;
}

export async function runAssistantTool(toolName, args, { signal } = {}) {
  if (!args || typeof args !== "object" || Array.isArray(args)) {
    throw new Error("Assistant tool arguments must be an object.");
  }
  const response = await api.post("/assistant/realtime/tool", {
    tool_name: toolName, arguments: args,
  }, { signal });
  const body = response?.data;
  if (body?.error === true || body?.error === 1 || body?.success === false) {
    throw new Error(body?.message || "Assistant tool failed.");
  }
  return body;
}
